import React from 'react';
import { useSiteSettings, shortUrl } from '../context/SiteSettingsContext.tsx';
import ContactWidgets from '../components/ContactWidgets.tsx';

const About: React.FC = () => {
    const { settings, stats } = useSiteSettings();

    return (
        <div className="container mx-auto px-6 py-12">
            <div className="max-w-4xl mx-auto">
                {/* Заголовок */}
                <div className="text-center mb-12">
                    <h1 className="text-4xl font-bold mb-4 gradient-text">О себе</h1>
                    <div className="w-24 h-1 bg-gradient-to-r from-blue-600 to-purple-600 mx-auto rounded-full"></div>
                </div>

                {/* Основной контент */}
                <div className="bg-white rounded-xl shadow-lg p-8 mb-8">
                    {/* Личные качества */}
                    <div className="prose prose-lg max-w-none mb-8">
                        <div className="grid md:grid-cols-2 gap-6">
                            <div className="space-y-4">
                                <div className="flex items-start space-x-3">
                                    <div className="w-2 h-2 bg-blue-500 rounded-full mt-3 flex-shrink-0"></div>
                                    <p className="text-gray-700 leading-relaxed">
                                        Ответственный и целеустремлённый, всегда довожу начатое до конца.
                                    </p>
                                </div>

                                <div className="flex items-start space-x-3">
                                    <div className="w-2 h-2 bg-blue-500 rounded-full mt-3 flex-shrink-0"></div>
                                    <p className="text-gray-700 leading-relaxed">
                                        Быстро адаптируюсь к новым технологиям и рабочим процессам.
                                    </p>
                                </div>

                                <div className="flex items-start space-x-3">
                                    <div className="w-2 h-2 bg-blue-500 rounded-full mt-3 flex-shrink-0"></div>
                                    <p className="text-gray-700 leading-relaxed">
                                        Внимателен к деталям, придерживаюсь принципов чистого кода и оптимальных решений.
                                    </p>
                                </div>
                            </div>

                            <div className="space-y-4">
                                <div className="flex items-start space-x-3">
                                    <div className="w-2 h-2 bg-purple-500 rounded-full mt-3 flex-shrink-0"></div>
                                    <p className="text-gray-700 leading-relaxed">
                                        Люблю разрабатывать сложные системы и решать нетривиальные задачи.
                                    </p>
                                </div>

                                <div className="flex items-start space-x-3">
                                    <div className="w-2 h-2 bg-purple-500 rounded-full mt-3 flex-shrink-0"></div>
                                    <p className="text-gray-700 leading-relaxed">
                                        Умею работать в команде, но также эффективно справляюсь с индивидуальными задачами.
                                    </p>
                                </div>

                                <div className="flex items-start space-x-3">
                                    <div className="w-2 h-2 bg-purple-500 rounded-full mt-3 flex-shrink-0"></div>
                                    <p className="text-gray-700 leading-relaxed">
                                        Постоянно совершенствую свои навыки и изучаю новые технологии.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Ссылки и контакты */}
                <div className="grid md:grid-cols-2 gap-6">
                    {/* GitHub */}
                    {settings.githubUrl && (
                    <div className="bg-white rounded-lg shadow-md p-6 text-center hover:shadow-lg transition-shadow">
                        <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                            <svg className="w-6 h-6 text-gray-600" fill="currentColor" viewBox="0 0 24 24">
                                <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" />
                            </svg>
                        </div>
                        <h3 className="text-lg font-semibold mb-2">GitHub репозитории</h3>
                        <a
                            href={settings.githubUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-blue-600 hover:text-blue-800 transition-colors break-all"
                        >
                            {shortUrl(settings.githubUrl)}
                        </a>
                    </div>
                    )}

                    {/* YouTube */}
                    {settings.youtubeUrl && (
                    <div className="bg-white rounded-lg shadow-md p-6 text-center hover:shadow-lg transition-shadow">
                        <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                            <svg className="w-6 h-6 text-red-600" fill="currentColor" viewBox="0 0 24 24">
                                <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
                            </svg>
                        </div>
                        <h3 className="text-lg font-semibold mb-2">YouTube канал</h3>
                        <a
                            href={settings.youtubeUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-blue-600 hover:text-blue-800 transition-colors text-sm"
                        >
                            Мой канал на YouTube
                        </a>
                    </div>
                    )}
                </div>

                {/* Дополнительная информация */}
                <div className="mt-12 text-center">
                    <p className="text-gray-600 text-lg mb-4">
                        {stats.experienceYears !== null ? `Более ${stats.experienceYears} лет опыта` : 'Большой опыт'} в разработке программного обеспечения и автоматизации
                    </p>
                    <ContactWidgets className="justify-center mb-6" />
                    <div className="flex justify-center space-x-8 text-sm text-gray-500">
                        <span>💼 Инженер-программист</span>
                        <span>🎯 STM32 • ESP32 • ПЛК • IoT</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default About; 